import { render } from "./ServiceItsCertifiedComp.vue?vue&type=template&id=25c3dada&scoped=true"
import script from "./ServiceItsCertifiedComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsCertifiedComp.vue?vue&type=script&lang=js"

import "./ServiceItsCertifiedComp.vue?vue&type=style&index=0&id=25c3dada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c3dada"]])

export default __exports__